import { render } from "./MarkdownMetadata.vue?vue&type=template&id=2286abb7&scoped=true"
import script from "./MarkdownMetadata.vue?vue&type=script&lang=js"
export * from "./MarkdownMetadata.vue?vue&type=script&lang=js"

import "./MarkdownMetadata.vue?vue&type=style&index=0&id=2286abb7&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2286abb7"]])

export default __exports__